import { render, staticRenderFns } from "./VantActivityNewUserPop.vue?vue&type=template&id=46fa7d4a&"
import script from "./VantActivityNewUserPop.vue?vue&type=script&lang=js&"
export * from "./VantActivityNewUserPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports